export default __webpack_public_path__ + "static/media/home_analytics_avatar.7e5060c1.svg";